import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { VernostServiceService } from "../../../../services/vernost-service.service";
import { saveAs } from "file-saver";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";
import { CommonService } from "../../../../services/common.service";
@Component({
  selector: "app-pg-report",
  templateUrl: "./pg-report.component.html",
  styleUrls: ["./pg-report.component.css"],
  providers: [DatePipe]
})
export class PgReportComponent implements OnInit {
  ngAfterViewInit() { }

  @ViewChild("input", { read: MatInput }) input: MatInput;
  @ViewChild("input2", { read: MatInput }) input2: MatInput;
  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;
  isOrd = false;
  arr1: any = [];
  screentitle: string = "PG Report";
  invaliddate = false;
  tomorrow;
  tomorrow1;
  searchlist: boolean = true;
  downd = true;
  disablebtn = true;
  newDate: any = new Date();
  isTicket: boolean = false;
  bookingdate: boolean = false;
  journeydate: boolean = false;
  search_details;
  booking_ref: any = "asdasd";
  page: number = 1;
  search_detail_list: any = [];
  arr: any = [];
  existingbooking: boolean = true;
  bookinglist: boolean = false;
  pgr_booking_details: any = "";
  segment_details: any = "";
  pax_detail: any = "";
  loader: any = false;
  uid;
  cancelbtn;
  BOOKING_STATUS;
  final;
  cancelHistory: any = [];
  isCancelOpen: boolean = false;
  isJpNumber: boolean = false;
  isPnr = false;
  noresult: any = "";
  disabledown = true;
  payment_status: any = [
    { key: "2", value: "Success" },
    { key: "4", value: "Failed" }
  ];
  myDate: any = new Date();
  isTicketNo: boolean = false;
  typeOfRedemption: any = "A";
  typeOfRedem: any = "A";
  constructor(
    private vernostService: VernostServiceService,
    private commonService: CommonService,
    private router: Router,
    private datePipe: DatePipe
  ) { }
  ngOnInit() {
    // this.myDate.setDate(this.myDate.getDate() - 1)
    this.isJpNumber = false;
    this.cancelbtn = true;
    this.isCancelOpen = false;
    this.uid = localStorage.getItem("uid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    this.search_details = {
      jp_number: "",
      airlinepnr: "",
      ticket_no: "",
      tripdate_from: "",
      tripdate_to: "",
      bookingdate_from: "",
      bookingdate_to: "",
      Ticket_No: "",
      order_id: "",
      status: "E",
      type: ""
    };
    //  this.checkempty();
  }

  searchForm() {
    this.existingbooking = true;
    this.bookinglist = false;
    this.searchData(2);
  }
  downloadFile(file_name) {
    var fname = file_name + "out.csv";
    this.vernostService.downloadFile(fname).subscribe(
      data => {
        // console.log(JSON.stringify(fname));
        saveAs(data, "PG_Report.csv");
      },
      err => { }
    );
  }
  selectTypeOfRedemption(type) {
    this.typeOfRedemption = type;
  }
  orderValidation() {
    // console.log("in console");
    var regex = /^[A-Za-z0-9_]+$/;

    var JPNo = this.search_details.order_id;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("ordNO").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("orErr").style.color = "red";
      this.isOrd = true;
    } else {
      document.getElementById("orErr").innerHTML = "";
      this.isOrd = false;
    }
  }

  // jpNumberValidation1() {
  //   this.disablebtn = false;
  //   var JPNo = this.search_details.jp_number;
  //   if (JPNo.length > 0) {
  //     if (JPNo.length < 9) {
  //       document.getElementById("JpErr").innerHTML =
  //         "Please enter 9 digit JP Number";
  //       document.getElementById("JpErr").style.color = "red";
  //       this.isJpNumber = true;
  //     } else {
  //       document.getElementById("JpErr").innerHTML = "";
  //       this.isJpNumber = false;
  //     }
  //   }
  // }
  ticketValidation() {
    var Ticket_No = this.search_details.Ticket_No;
    // console.log("Ticket_No", Ticket_No.length);
    if (Ticket_No.length <= 0) {
      this.isTicketNo = true;
    } else {
      this.isTicketNo = false;
    }
  }
  IsEmptyVal: boolean = false;
  isEmpty() {
    // console.log("QQQ", this.search_details.jp_number.length, "WWW", this.search_details.airlinepnr.length)
    if (this.search_details.jp_number == '' && this.search_details.airlinepnr == '' &&
      this.search_details.order_id == '' && this.search_details.Ticket_No == '' &&
      this.search_details.status == "E" && (this.search_details.bookingdate_from == ""
        || this.search_details.bookingdate_to == "")) {
      // console.log("YES");
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;
      // console.log("NO");
    }

  }
  pageCount(count) {
    this.page = count;
    this.searchData(2)
    // console.log("P:::", this.p);
  }
  searchData(flag) {
    this.noresult = "";
    if (this.isJpNumber == false && this.isPnr == false
      && this.isOrd == false) {
      // console.log("dsddssssssssss");
      var Todate = this.search_details.bookingdate_to;
      if (Todate != "") {
        Todate.setDate(Todate.getDate());
      }
      this.search_details.bookingdate_from = this.datePipe.transform(
        this.search_details.bookingdate_from,
        "yyyy-MM-dd"
      );
      Todate = this.datePipe.transform(
        Todate,
        "yyyy-MM-dd"
      );
      this.loader = true;
      this.searchlist = false;
      this.cancelbtn = true;
      this.noresult = "";
      var ordid = "";
      var FromDate = this.search_details.bookingdate_from;
      var todate = Todate;
      // console.log("jp", "00" + this.search_details.jp_number);
      // console.log("airlinepnr", this.search_details.airlinepnr);
      // console.log("ticket_no", this.search_details.ticket_no);
      // console.log("tripdrom", this.search_details.tripdate_from);
      // console.log("tripto", this.search_details.tripdate_to);
      // console.log("boofrom", this.search_details.bookingdate_from);
      // console.log("bookto", this.search_details.bookingdate_to);
      var BOOKING_REF_NO = (this.search_details.order_id.toString().length <= 15 ? this.search_details.order_id.slice(4, this.search_details.order_id.length) : this.search_details.order_id);

      if (
        this.search_details.order_id != undefined &&
        this.search_details.order_id != ""
      ) {
        ordid = BOOKING_REF_NO;
      }
      var AirLine_Pnr = this.search_details.airlinepnr;
      var jp_number = "";
      if (this.typeOfRedemption == 'A') {
        jp_number = this.search_details.jp_number;
      }
      if (this.typeOfRedemption == 'R') {
        jp_number = "00" + this.search_details.jp_number
      }
      var data = {
        jp_number: jp_number,
        airlinepnr: AirLine_Pnr.toUpperCase(),
        ordid: ordid,
        fromdate: FromDate,
        todate: todate,
        booking_fromdate: FromDate,
        booking_todate: todate,
        Ticket_No: this.search_details.Ticket_No,
        status: this.search_details.status,
        type: flag,
        pagination: this.page,
        typeOfRedemption: this.typeOfRedemption

      };

      // console.log("data", data);
      if (flag == 1) {
        this.vernostService.downloadPgData(data).subscribe(
          result => {
            // console.log("result", result.size);
            this.noresult = "";
            if (result.size != 0) {
              saveAs(result, "PgReport.csv");
            } else {
              this.noresult = "Result Not Found";
            }
            this.loader = false;
          },
          err => { }
        );
      } else {
        this.vernostService.getPgData(data).subscribe(response => {
          // console.log("resopnse", response);
          this.typeOfRedem = this.typeOfRedemption;
          this.arr = response;
          this.search_detail_list = this.arr.result;
          this.loader = false;
          this.disabledown = false;

          if (
            this.search_detail_list.length == 0 ||
            this.search_detail_list == undefined ||
            this.search_detail_list == ""
          ) {
            // alert("here");
            this.noresult = "Result Not Found";
          }
        });
      }
    }
  }

  pnrValidation1() {
    this.disablebtn = false;
    var JPNo = this.search_details.airlinepnr;
    if (JPNo.length > 0) {
      if (JPNo.length < 6) {
        document.getElementById("pnrNO").innerHTML =
          "Please enter 6 digit PNR No ";
        document.getElementById("pnrNO").style.color = "red";
        this.isPnr = true;
      } else {
        document.getElementById("pnrNO").innerHTML = "";
        this.isPnr = false;
      }
    }
  }

  orderValidation1() {
    this.disablebtn = false;
    var JPNo = this.search_details.order_id;
    if (JPNo.length > 0) {
      if (JPNo.length < 14) {
        document.getElementById("orErr").innerHTML =
          "Please enter 18 digit Booking Reference No ";
        document.getElementById("orErr").style.color = "red";
        this.isOrd = true;
      } else {
        document.getElementById("orErr").innerHTML = "";
        this.isOrd = false;
      }
    }
  }

  jpNumberValidation1() {
    this.disablebtn = false;
    var JPNo = this.search_details.jp_number;
    if (JPNo.length > 0) {
      if (JPNo.length < 9) {
        document.getElementById("JpErr").innerHTML =
          "Please enter the correct JP number.";
        document.getElementById("JpErr").style.color = "red";
        this.isJpNumber = true;
      } else {
        document.getElementById("JpErr").innerHTML = "";
        this.isJpNumber = false;
      }
    }
  }
  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }
  checkempty() {
    if (
      this.search_details.jp_number.length == 0 &&
      this.search_details.airlinepnr.length == 0 &&
      this.search_details.ticket_no.length == 0
    ) {
      this.disablebtn = true;
    }

    if (
      (this.search_details.jp_number.length != 0 ||
        this.search_details.airlinepnr.length != 0 ||
        this.search_details.ticket_no.length != 0) &&
      (this.search_details.bookingdate_from != "" &&
        this.search_details.bookingdate_to != "")
    ) {
      this.disablebtn = false;
    }

    if (
      (this.search_details.jp_number.length != 0 ||
        this.search_details.airlinepnr.length != 0 ||
        this.search_details.ticket_no.length != 0) &&
      (this.search_details.bookingdate_from == "" &&
        this.search_details.bookingdate_to == "")
    ) {
      this.disablebtn = false;
    }

    if (
      this.search_details.bookingdate_from == "" &&
      this.search_details.bookingdate_to != ""
    ) {
      this.disablebtn = true;
    }

    if (
      this.search_details.bookingdate_from != "" &&
      this.search_details.bookingdate_to == ""
    ) {
      this.disablebtn = true;
    }
  }

  book_details(param, type) {
    if (type == "book") {
      this.loader = true;
    }
    let data = {
      booking_ref: param
    };
    this.getBookingDetails(data);

    if (type == "book") {
      this.existingbooking = false;
      this.bookinglist = true;
      this.isCancelOpen = false;
    } else {
      this.isCancelOpen = true;
      //this.confirmMessage(this.booking_details.Ticket_No,type);
    }
  }

  getBookingDetails(data) {
    this.vernostService.getBookingDetails(data).subscribe(response => {
      this.loader = false;
      this.pgr_booking_details = response[0].booking[0];
      this.segment_details = response[0].segment_details;
      this.pax_detail = response[0].pax_detail;
      this.BOOKING_STATUS = this.pgr_booking_details.BOOKING_STATUS;
    });
  }

  cancelBooking(ticket_no, type) {
    this.cancelbtn = true;
    var array = {
      ticket_no: ticket_no,
      FB_BOOKING_REF_NO: this.pgr_booking_details.Booking_Ref,
      ORDER_ID: this.pgr_booking_details.ORDER_ID,
      ORIGIN: this.segment_details[0].ORIGIN,
      DESTINATION: this.segment_details[0].DESTINATION,
      TRANSACTION_ID: this.pgr_booking_details.TRANSACTION_ID,
      TRIP_ID: this.pgr_booking_details.TRIP_ID,
      MEMBER_NO: this.pgr_booking_details.MEMBER_NO,
      PRODUCT_TYPE: this.pgr_booking_details.PRODUCT_TYPE,
      TIER: "",
      CANCELLED_BY: this.uid,
      CREATED_BY: this.uid
    };

    this.vernostService
      .cancelHistoryFlightBooking(array)
      .subscribe(response => {
        if (response[0].status == "Success") {
          // console.log(response[0].message);
          this.cancelbtn = false;
        }
        if (response[0].status == "failed") {
          // console.log(response[0].message);
          this.cancelbtn = true;
        }
      });
    var updateArray = {
      BOOKING_STATUS: 11,
      TRANSACTION_STATUS: "",
      MEMBER_POINT_BALANCE: "6000",
      ORDER_ID: this.pgr_booking_details.ORDER_ID,
      FB_BOOKING_REF_NO: this.pgr_booking_details.Booking_Ref
    };
    this.vernostService.cancelFlightBooking(updateArray).subscribe(response => {
      if (this.isCancelOpen == true) {
        this.searchData(2);
      }
    });
  }
  jpNumberValidation() {
    var JPNo = this.search_details.jp_number;
    this.isJpNumber = this.commonService.validation('jpnumbervalidation', /^[A-Za-z0-9_]+$/, JPNo);
  }

  pnrValidation() {
    // console.log("in console");
    var regex = /^[A-Za-z0-9_]+$/;

    var JPNo = this.search_details.airlinepnr;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("pnrNO").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("pnrNO").style.color = "red";
      this.isPnr = true;
    } else {
      document.getElementById("pnrNO").innerHTML = "";
      this.isPnr = false;
    }
  }

  tickValidation() {
    // console.log("in tick");
    var regex = /^[A-Za-z0-9_]+$/;

    var JPNo = this.search_details.ticket_no;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("tickNO").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("tickNO").style.color = "red";
      this.isPnr = true;
    } else {
      document.getElementById("tickNO").innerHTML = "";
      this.isPnr = false;
    }
  }

  toggleDisable1() {
    this.bookingdate = true;

    if (
      this.search_details.tripdate_from.length != "" ||
      this.search_details.tripdate_to.length != ""
    ) {
      this.bookingdate = true;
    } else {
      this.bookingdate = false;
    }

    if (this.search_details.tripdate_from.length != "") {
      this.tomorrow = this.search_details.tripdate_from;
      this.tomorrow.setDate(this.tomorrow.getDate() + 1);
    }
  }
  toggleDisable2() {
    this.journeydate = true;
    this.search_details.bookingdate_to = "";
    // if (
    //   this.search_details.bookingdate_from.length != "" ||
    //   this.search_details.bookingdate_to.length != ""
    // ) {
    //   this.journeydate = true;
    // } else {
    //   this.journeydate = false;
    // }

    // if (this.search_details.bookingdate_from.length != "") {
    //   this.tomorrow1 = this.search_details.bookingdate_from;
    //   this.tomorrow1.setDate(this.tomorrow1.getDate() + 1);
    // }
  }

  reset() {
    this.input.value = "";
    this.search_details.tripdate_from = "";
    this.tomorrow = "";
  }

  reset2() {
    this.input2.value = "";
    this.search_details.tripdate_to = "";
  }

  reset3() {
    this.input3.value = "";

    this.search_details.bookingdate_from = "";
    this.final = "";
    this.isEmpty();
  }

  reset4() {
    this.input4.value = "";
    this.search_details.bookingdate_to = "";
    this.isEmpty();
  }

  checkStatus1() {
    this.checkempty();
    this.downd = (this.search_details.bookingdate_from != "" &&
      this.search_details.bookingdate_to != "") ? false : true;
  }

  incresedate() {
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrow);

    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);

    // alert(this.final);
    //alert(this.search_details.bookingdate_from);
  }

  checkDate() {
    this.invaliddate = false;
    if (
      this.search_details.bookingdate_to != "" &&
      this.search_details.bookingdate_to != null &&
      this.search_details.bookingdate_to != " "
    ) {
      var FromDate = this.search_details.bookingdate_from;
      // FromDate.setDate(FromDate.getDate() - 1);
      if (
        FromDate >=
        this.search_details.bookingdate_to
      ) {
        this.invaliddate = true;
      }
    }
  }
}
